import { Context, CustomQuery } from '@vue-storefront/core';
import { ApiResult } from '../../types';

// 未读站内信列表
export default async function UnReadMessageList(context: Context, params: CustomQuery): Promise<ApiResult> {
    const url = new URL('/mall/message/unread', context.config.api.url);
    const { data: res } = await context.client.post(url.href, params);
    return res;
}
